"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _reactEmotion = require("react-emotion");

var _styleConsts = require("../utils/styleConsts");

var label = function label(theme, showBorder, focus) {
  return (
    /*#__PURE__*/
    (0, _reactEmotion.css)(_styleConsts.buttonReset, "\n  position:relative;min-width:100%;height:36px;padding:12px 12px 12px 0px;border:1px solid transparent;border-radius:2px;outline:none;fill:", theme.color.dark.iron, ";color:", theme.color.dark.iron, ";& .IconSearch{width:14px;height:14px;margin-right:0px;align-self:center;}", (focus || showBorder) && "\n    border: 1px solid ".concat(theme.color.dark.sapphire, ";\n    fill: ").concat(theme.color.dark.white, ";\n    color: ").concat(theme.color.dark.white, ";\n  "))
  );
};

var input = function input(theme) {
  return (
    /*#__PURE__*/
    (0, _reactEmotion.css)("height:'36px';margin-left:10px;outline:none;padding:0;font-size:12px;&::placeholder{color:", theme.color.dark.iron, ";}&:focus::placeholder{color:", theme.color.dark.white, ";}")
  );
};

var _default = {
  label: label,
  input: input
};
exports.default = _default;